import { graphql } from 'react-apollo';
import gql from 'graphql-tag';
import { compose, withProps } from 'recompose';
import { querySelector } from '../../../utils';
import queryMetaHandler from '../../../utils/queryMetaHandler';
import omitProps from '../../../utils/omitProps';

const TicketNumberDetails = gql`
  fragment TicketNumberDetails on TicketNumber {
    id
    number
    ticket {
      id
      jobId: job_id
      date {
        display
      }
      department {
        id
        name
      }
      district {
        id
        name
      }
      equipment {
        edges {
          node {
            id
            equipmentNumber: equipment_number
          }
        }
      }
      well {
        id
        name
        lease {
          id
          name
          operator {
            id
            name
          }
        }
      }
    }
    users {
      edges {
        node {
          id
          fullname
        }
      }
    } 
  }
`;

const GetMissingTicketNumberDetails = gql`
  query MissingTicketNumberSequence($id: String!) {
    missingTicketNumberSequence: missing_ticket_number_sequence(id: $id) {
      id
      previous {
        ...TicketNumberDetails
      }
      next {
        ...TicketNumberDetails
      }
      missingTicketNumbers: missing_ticket_numbers {
        id
        ticketNumber: ticket_number
        expected
        reason
      }
    }
  }
  ${TicketNumberDetails}
`;


const mapDataToProps = withProps((props) => {
  const { data } = props;
  const [previousTicket] = querySelector(data, '$.missingTicketNumberSequence.previous', []);
  const [nextTicket] = querySelector(data, '$.missingTicketNumberSequence.next', []);
  const [missingTicketNumbers] = querySelector(data, '$.missingTicketNumberSequence.missingTicketNumbers', []);
  return {
    previousTicket,
    nextTicket,
    missingTicketNumbers,
  };
});


const withData = graphql(GetMissingTicketNumberDetails);


const enhance = compose(
  withData,
  queryMetaHandler,
  mapDataToProps,
  omitProps(['data']),
);


export default enhance;
